import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import PromoCode from './PromoCode'
import Promotion from './Promotion'
import Discount from './Discount'
import PaymentProcess from './PaymentProcess'
import Tax from './Tax'
import { Row, Col, Divider, Form, Input } from 'antd'
import {
  loadSaleOrderJson,
  loadIsNotesRowVisible,
  loadIsDiscountRowVisible,
  loadFormSellNote,
  loadIsDiscountPopoverVisible,
  loadRowDataUpdated
} from '../../appRedux/actions/MainSale'
import { isEmpty } from 'lodash'
import {
  fetchCurrentSalesOrder,
  formatDigits,
  getDecryptID,
  isEmptyObject
} from '../../appRedux/actions'
import { manageIndexedCartJson } from '../../appRedux/actions/saleIndexDB'
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}
const CartDetails = props => {
  const { discountPerm } = props
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const getCurrData = props.getCurrData
    ? props.getCurrData
    : {
        currencyCode: '',
        currencyName: '',
        currencySymbol: ''
      }
  const formSellNote = useSelector(({ MainSale }) => MainSale.formSellNote)
  const isRowDataUpdated = useSelector(
    ({ MainSale }) => MainSale.isRowDataUpdated
  )
  const getIsNotesRowVisible = useSelector(
    ({ MainSale }) => MainSale.getIsNotesRowVisible
  )
  const getIsDiscountRowVisible = useSelector(
    ({ MainSale }) => MainSale.getIsDiscountRowVisible
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const getSaleOrderJson = useSelector(
    ({ MainSale }) => MainSale.getSaleOrderJson
  )
  const getReduxSaleProductJsonData = useSelector(
    ({ Sell }) => Sell.saleProductJsonData
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  )

  React.useEffect(() => {
    let mounted = true
    if (
      mounted &&
      isRowDataUpdated &&
      getSaleOrderJson &&
      !isEmptyObject(getSaleOrderJson)
    ) {
      form.setFieldsValue({
        SellNotes: getSaleOrderJson.Notes
      })
      dispatch(loadRowDataUpdated(false))
    }

    return () => (mounted = false)
  }, [isRowDataUpdated])

  const handleDiscountRowVisibleChange = isRowVisible => {
    // setIsDiscountRowVisible(isRowVisible);
    dispatch(loadIsDiscountRowVisible(isRowVisible))
  }

  const handleNotesRowVisibleChange = isRowVisible => {
    if (!isRowVisible) {
      form.setFieldsValue({ SellNotes: '' })
      dispatch(loadFormSellNote(''))
      setSellNotesOnJson()
    }
    // setIsNotesRowVisible(isRowVisible);
    dispatch(loadIsNotesRowVisible(isRowVisible))
  }

  const handleChangeSellNotes = e => {
    dispatch(loadFormSellNote(e.target.value))
    setSellNotesOnJson()
  }

  function setSellNotesOnJson () {
    let saleOrderJson = getSaleOrderJson
    saleOrderJson.Notes = form.getFieldValue('SellNotes')
    // setSaleOrderJson(saleOrderJson);
    dispatch(loadSaleOrderJson(saleOrderJson))
    manageIndexedCartJson(saleOrderJson, true, false, false, 'setSellNotesOnJson --> CartDetails')
  }

  return (
    <div id='bottom-cart-footer' className='sale-list-footer div-flow'>
      <Row className='sale-list-footer-item-1 cart-sl'>
        <Col md={10} xs={10} sm={10}>
          <p className='custom-font-size-weight custom-font-color-black'>
            <IntlMessages id='sell.sell.add' />
          </p>
        </Col>

        <Col md={6} xs={6} sm={6}>
          {getIsDiscountRowVisible ||
          getIsRefundSale ||
          getDecryptID(getCurrentSalesOrderStatusID) ==
            getDecryptID(fetchCurrentSalesOrder('LayBy')) ||
          getDecryptID(getCurrentSalesOrderStatusID) ==
            getDecryptID(fetchCurrentSalesOrder('On Account')) ? (
            ''
          ) : (
            <p
              className='custom-font-size-weight dk-link text-rite'
              style={{
                color:
                  getReduxSaleProductJsonData &&
                  getReduxSaleProductJsonData.length < 1
                    ? '#afafaf'
                    : ''
              }}
              onClick={() => {
                if (
                  getReduxSaleProductJsonData &&
                  getReduxSaleProductJsonData.length > 0
                ) {
                  dispatch(loadIsDiscountPopoverVisible(true))
                  handleDiscountRowVisibleChange(true)
                }
              }}
            >
              <IntlMessages id='sell.sell.discount1' />
            </p>
          )}
        </Col>
        {}
        <Col md={6} xs={6} sm={6}>
          {getIsNotesRowVisible ? (
            ''
          ) : (
            <p
              className='custom-font-size-weight dk-link text-rite'
              style={{
                color:
                  getReduxSaleProductJsonData &&
                  getReduxSaleProductJsonData.length < 1
                    ? '#afafaf'
                    : ''
              }}
              onClick={() => {
                if (
                  getReduxSaleProductJsonData &&
                  getReduxSaleProductJsonData.length > 0
                ) {
                  handleNotesRowVisibleChange(true)
                }
              }}
            >
              <IntlMessages id='sell.sell.note' />
            </p>
          )}
        </Col>
      </Row>

      <Divider />

      {getIsNotesRowVisible && (
        <>
          <Row className='sale-list-footer-item-1 notes-div cart-sl'>
            <Col md={20} xs={16} sm={18} className='custom-padding-0px'>
              <Form form={form} {...formItemLayout} name='saleNote'>
                <Form.Item
                  className='ant-form-item-label-custom ant-form-custom-alignment sell-notes-colon'
                  name='SellNotes'
                  label={
                    <p className='custom-font-size-weight custom-font-color-black custom-mg-btm '>
                      <IntlMessages id='sell.sell.notes' />
                    </p>
                  }
                >
                  <Input.TextArea
                    value={formSellNote}
                    defaultValue={formSellNote}
                    className='product-notes-hg'
                    placeholder='Enter a note about this sale'
                    onChange={e => handleChangeSellNotes(e)}
                    showCount
                    maxLength={2000}
                  />
                </Form.Item>
              </Form>
            </Col>

            <Col md={4} xs={8} sm={6} className='custom-col-text-center del-btn-div no-mar-left'>
              <span>
                <a
                  onClick={() => {
                    handleNotesRowVisibleChange(false)
                  }}
                  className='trash-icon-btn'
                >
                  {' '}
                  <i className='icon icon-trash' />
                </a>
              </span>
            </Col>
          </Row>

          <Divider className='' />
        </>
      )}

      {getIsTaxExclusive && (
        <>
          <Row className='sale-list-footer-item-1 cart-sl'>
            <Col md={16}>
              <p className='custom-font-size-weight custom-font-color-black'>
                <IntlMessages id='sell.sell.subtotal' />
              </p>
            </Col>

            <Col md={8}>
              <p className='custom-font-size-weight custom-font-color-black text-rite'>
                {getCurrData.currencyCode != null
                  ? getCurrData.currencyCode
                  : getCurrData.currencyName != null
                  ? getCurrData.currencyName
                  : getCurrData.currencySymbol}{' '}
                {getSaleOrderJson != undefined &&
                getSaleOrderJson.finals != undefined &&
                getSaleOrderJson.finals.subtotal != undefined
                  ? formatDigits(
                      getSaleOrderJson.finals.subtotal,
                      getDefaultDecimalPlaces
                    )
                  : ''}
              </p>
            </Col>
          </Row>
          <Divider />
        </>
      )}
      <Discount getCurrData={getCurrData} discountPerm={discountPerm} />
      <Promotion getCurrData={getCurrData} />
      <Tax getCurrData={getCurrData} />
      <PaymentProcess getCurrData={getCurrData} />
    </div>
  )
}

export default CartDetails
